module.exports = __webpack_public_path__ + "static/media/ic_chevron-down_primary.017eb14f.svg";